import * as http from './http';
import { AllRequestData } from '../models/allRequestsdata';
import ApiService from './service';
import { Dict } from '../../models';
import { ApiResponse, ListSort, PaginatedApiResponse } from '../..';

export class RequestApiService extends ApiService {
  public async loadAllrequestdata(
    data: {
      page: number;
      search?: string;
      perPage: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<AllRequestData[]>> {
    const url = `${this.apiDomain}/api/all-requests/get-all-requests`;
    const response = await http.post<PaginatedApiResponse<AllRequestData[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async downloadAllrequest(
    data: {
      search?: string;
      columns: { label: string; source?: string }[];
      isDeal?: boolean;
    } & ListSort &
      Dict
  ): Promise<void> {
    const url = `${this.apiDomain}/api/all-requests/download`;

    const resposne = await http.downloadPostData(url, data, this.store);
    http.saveDownloadedFile(
      resposne.data,
      'application/application/vnd.openxmlformats',
      `Requests-${new Date()}.xlsx`
    );
  }
}
